import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from './auth.component';
import { AuthService } from './auth.service';
import { ApiServiceModule } from '../../services/api/api.module';
import { KngLoaderModule } from 'kinetic-angular';
import { LoggerServiceModule } from '../../services/logger/logger.module';

@NgModule({
	declarations: [AuthComponent],
	imports: [ CommonModule, ApiServiceModule, KngLoaderModule, LoggerServiceModule ],
	exports: [AuthComponent],
	providers: [AuthService]
})
export class AuthModule {}
